export default {
  data(){
      return {
        loading: false,
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10,
          showTotal: total => `共${total}条`
        },
        options: {
          grid: {
            left: 100,
            right: 5
          },
          legend: {
            textStyle: {
              color: "#9CA9CB",
              fontSize: 12
            },
          },
          xAxis: [{
            type: "category",
            data: [],
            axisLabel: {
              show: true,
              interval: 0,
            },
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: '#9CA9CB'
              }
            },
          }],
          yAxis: [{
            type: "value",
            data: [],
            axisLabel: {
              show: true,
            },
            nameTextStyle: {
              color: "#9CA9C",
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
                lineStyle: {
                color: '#9CA9CB'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#CAD3EB'
              }
            },
          }],
          series: [
            {
              data: [],
              type: "bar",
              itemStyle: {
                borderRadius: null,
                color: '#35CB54',
                barBorderRadius: [4, 4, 0, 0],
              },
              barWidth: 26,
            },
          ],
          dataZoom: [{
            show: true,
            startValue: 0,
            endValue: 10,
            zoomLock: true,
            type: 'slider',
            xAxisIndex: [0]
          }]
        },
        exportTypeMap: {
          1: {
            value: 'clicks',
            name: '点击指数',
            unit: ''
          },
          2: {
            value: 'impressions',
            name: '展示指数',
            unit: ''
          },
          3: {
            value: 'cpc',
            name: 'CPC',
            unit: '$'
          },
          4: {
            value: 'ctr',
            name: 'CTR',
            unit: '%'
          },
          5: {
            value: 'spend',
            name: '花费指数',
            unit: ''
          },
          6: {
            value: 'cpm',
            name: 'CPM',
            unit: '$'
          },
        }
      }
  },
  methods: {
		search() {
			this.pagination.current = 1
			this.getList()
		},
    handleTableChange(pagination) {
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
      this.getList()
		},
  }
}